module.exports = __webpack_public_path__ + "static/img/widget-4.8ecaaa55.png";